var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4463 26.5L32.335 20.7088H26.7782V16.9506C26.7782 15.3663 27.5544 13.8219 30.0432 13.8219H32.5694V8.89125C32.5694 8.89125 30.2769 8.5 28.085 8.5C23.5088 8.5 20.5175 11.2738 20.5175 16.295V20.7088H15.4307V26.5H20.5175V40.5H26.7782V26.5H31.4463Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.415e6496191b0da4f5726745e46bfe60.svg";
export { ForwardRef as ReactComponent };